var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeemgIconsCreateevent2023(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2723 20.4312L29.9536 8.30119C29.9536 8.30119 27.4451 4.35689 26.4549 4.35689C25.4482 4.35689 12.7076 16.4869 12.7076 16.4869L11.8659 20.3321L16.2723 20.4312Z",
    fill: "#FFC200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7127 7.88861C29.9041 6.25478 28.6828 4.83549 27.181 3.79578L27.0985 3.74627C26.8179 3.54823 26.4384 3.58123 26.1908 3.79578L12.1465 16.0248C12.0144 16.1403 11.9319 16.2888 11.8989 16.4538L11.0902 20.6292C11.0407 20.8602 11.1067 21.0913 11.2718 21.2728C11.4203 21.4379 11.6183 21.5204 11.8329 21.5204C11.8494 21.5204 11.8659 21.5204 11.8824 21.5204L16.0577 21.2068C16.2228 21.1903 16.3713 21.1243 16.4868 21.0253L30.5477 8.79629C30.7952 8.56525 30.8613 8.18567 30.7127 7.88861ZM15.6947 19.7215L12.7406 19.9361L13.3182 16.982L26.7354 5.29758C27.7091 6.04023 28.5178 6.98092 29.1119 8.03714L15.6947 19.7215Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7617 15.8597C25.3491 15.8597 25.0191 16.1898 25.0191 16.6024V25.5307C25.0191 26.2568 24.425 26.851 23.6988 26.851H7.39349C6.66734 26.851 6.07322 26.2568 6.07322 25.5307V9.22539C6.07322 8.49924 6.66734 7.90512 7.39349 7.90512H17.7741C18.1867 7.90512 18.5168 7.57505 18.5168 7.16247C18.5168 6.74988 18.1867 6.41982 17.7741 6.41982H7.39349C5.84218 6.41982 4.58792 7.67407 4.58792 9.22539V25.5307C4.58792 27.082 5.84218 28.3363 7.39349 28.3363H23.6988C25.2501 28.3363 26.5044 27.082 26.5044 25.5307V16.6024C26.5044 16.1898 26.1743 15.8597 25.7617 15.8597Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeemgIconsCreateevent2023);
export default __webpack_public_path__ + "static/media/beemg-icons-createevent-2023.f87751c77d8e3ecc8c465bee700daede.svg";
export { ForwardRef as ReactComponent };